<template>
    <div class="menu-page">
        <v-card class="nd-border" flat>
            <v-card-title>
                Templates de Mensagem
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" class="d-flex flex-wrap justify-end">
                        <v-spacer></v-spacer>

                        <ib-btn color="primary" class="ml-2 mt-2" @click.native="openLink('https://business.facebook.com/latest/whatsapp_manager/message_templates')">
                            <v-icon>mdi-plus</v-icon>Gerenciador de modelos
                        </ib-btn>

                        <ib-btn color="primary" class="ml-2 mt-2" @click.native="openLink('https://business.facebook.com/latest/whatsapp_manager/template_library')">
                            <v-icon>mdi-plus</v-icon>Biblioteca de modelos
                        </ib-btn>

                        <ib-btn v-if="false" color="primary" class="ml-2 mt-2" @click.native="openNew">
                            <v-icon>mdi-plus</v-icon>Novo template
                        </ib-btn>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <v-data-table :headers="headers" :items="objects" :loading="loading">

                            <template v-slot:[`item.category`]="{ item }">
                                {{$whatsapp_template_categories.find(x => x.id === item.category)?.name}}
                            </template>


                            <template v-slot:[`item.status`]="{ item }">
                                {{$whatsapp_template_statuses.find(x => x.id === item.status)?.name}}
                            </template>


                            <template v-slot:[`item.actions`]="{ item }">
                                <div class="d-flex">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon :disabled="item.default" medium class="mr-2" color="error lighten-1" @click="confirmDeleteObject(item)" v-bind="attrs" v-on="on">mdi-trash-can-outline</v-icon>
                                        </template>
                                        <span>Apagar</span>
                                    </v-tooltip>
                                </div>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <ib-dialog v-model="dialog" scrollable max-width="1000" persistent>
            <v-card>
                <ib-dialog-header title="Novo template de mensagem" subtitle="Crie templates de mensagem de texto por aqui" :close="() => { dialog = false }"></ib-dialog-header>
                <v-card-text>
                    <v-row>
                        <v-col cols="12">
                            <ib-text-field class="pt-1" v-model="object.name" label="Nome do template" outlined hide-details="auto" />
                        </v-col>

                        <v-col cols="12">
                            <ib-autocomplete outlined v-model="object.category" :items="$whatsapp_template_categories" label="Categoria" item-text="name" item-value="id" clearable hide-details></ib-autocomplete>
                        </v-col>

                        <v-col cols="12">
                            <v-textarea class="pt-1 nd-text-field" v-model="object.body" label="Corpo da mensagem" rows="5" outlined hide-details="auto" :messages="`Variáveis devem ser numeradas da seguinte forma: {{1}} {{2}} {{3}} e assim por diante.`"> </v-textarea>
                        </v-col>

                        <v-col cols="12">
                            <v-menu offset-y>
                                <template #activator="{ on }">
                                    <ib-btn color="primary" class="ml-2 mt-2" v-on="on" :disabled="object.buttons.length >= 10">
                                        <v-icon>mdi-plus</v-icon>Adicionar botão
                                    </ib-btn>
                                </template>

                                <v-list>
                                    <v-list-item class="cursor-pointer" @click="addButton({ type: 'QUICK_REPLY', text: 'Texto do botão' })">
                                        <v-list-item-title>
                                            <v-icon size="25" class="mr-1" color="primary">
                                                mdi-reply-outline
                                            </v-icon>
                                            Personalizado
                                        </v-list-item-title>
                                    </v-list-item>

                                    <v-list-item class="cursor-pointer" :disabled="object.buttons?.find(b => b.type === 'URL')" @click="addButton({ type: 'URL', text: 'Visite meu site', url: 'https://www.meusite.com' })">
                                        <v-list-item-title>
                                            <v-icon size="25" class="mr-1" color="primary">
                                                mdi-open-in-new
                                            </v-icon>
                                            Acessar site
                                        </v-list-item-title>
                                    </v-list-item>

                                    <v-list-item class="cursor-pointer" :disabled="object.buttons?.find(b => b.type === 'PHONE_NUMBER')" @click="addButton({ type: 'PHONE_NUMBER', text: 'Ligue agora', phone_number: '+5511955555555' })">
                                        <v-list-item-title>
                                            <v-icon size="25" class="mr-1" color="primary">
                                                mdi-phone-outline
                                            </v-icon>
                                            Ligar
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </v-col>

                        <v-col cols="12" v-for="(btn, index) in object.buttons" :key="`btn_${index}`" class="d-flex align-center">
                            <v-row v-if="btn.type === 'QUICK_REPLY'">
                                <v-col cols="12" class="d-flex align-center">
                                    <ib-text-field class="pt-1" v-model="btn.text" maxlength="25" :label="`Texto do botão ${index + 1}`" outlined hide-details="auto" />
                                </v-col>
                            </v-row>

                            <v-row v-if="btn.type === 'URL'">
                                <v-col cols="6">
                                    <ib-text-field class="pt-1" v-model="btn.text" maxlength="25" :label="`Texto do botão ${index + 1}`" outlined hide-details="auto" />
                                </v-col>

                                <v-col cols="6">
                                    <ib-text-field class="pt-1" v-model="btn.url" maxlength="1000" label="URL do site" outlined hide-details="auto" />
                                </v-col>
                            </v-row>

                            <v-row v-if="btn.type === 'PHONE_NUMBER'">
                                <v-col cols="6">
                                    <ib-text-field class="pt-1" v-model="btn.text" maxlength="25" :label="`Texto do botão ${index + 1}`" outlined hide-details="auto" />
                                </v-col>

                                <v-col cols="6">
                                    <ib-text-field class="pt-1" v-model="btn.phone_number" maxlength="1000" label="Telefone no formato +5511955555555" outlined hide-details="auto" />
                                </v-col>
                            </v-row>

                            <v-btn small class="ml-2" icon color="error lighten-2" @click="object.buttons.splice(index, 1)">
                                <v-icon>mdi-trash-can</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions class="d-flex flex-wrap">
                    <ib-btn outlined color="gray200" @click.native="dialog = false">
                        <div class="gray1000--text">
                            Cancelar
                        </div>
                    </ib-btn>

                    <v-spacer />

                    <ib-btn class="mb-2" color="primary" @click.native="save" :loading="loading">
                        Salvar
                    </ib-btn>
                </v-card-actions>
            </v-card>
        </ib-dialog>

        <ib-dialog v-model="deleteDialog" overlay-opacity="0.5" overlay-color="black" max-width="350">
            <v-card>
                <ib-dialog-header title="Apagar template de mensagem" :close="() => { deleteDialog = false }"></ib-dialog-header>

                <v-card-text>Tem certeza que deseja apagar o template <b>{{ object.name }}</b>?</v-card-text>
                <v-card-actions>
                    <ib-btn outlined color="gray200" @click="deleteDialog = false;">
                        <div class="gray1000--text">
                            Cancelar
                        </div>
                    </ib-btn>

                    <v-spacer />

                    <ib-btn color="error" @click="deleteDialog = false; deleteObject(object)">
                        Apagar
                    </ib-btn>
                </v-card-actions>
            </v-card>
        </ib-dialog>
    </div>
</template>

<script>
import Api from "@/lib/Api";
import { emitToastr } from "@/lib/Utils";

export default {
    name: "TemplatesView",

    data() {
        return {
            objects: [],
            object: { buttons: [] },
            loading: true,
            dialog: false,
            deleteDialog: false,
            headers: [
                { text: 'Nome', value: 'name', sortable: false },
                { text: 'Categoria', value: 'category', sortable: false },
                { text: 'Status', value: 'status', sortable: false },
                { text: 'Ações', value: 'actions', sortable: false }
            ]
        };
    },
    computed: {
        currentUser() {
            return this.$store.state.currentUser;
        }
    },

    async mounted() {
        await this.getObjects();
    },

    methods: {
        async getObjects() {
            this.loading = true;
            const resp = await Api.getTemplateMessages();
            this.loading = false;

            if (!resp.error && resp.message) {
                this.objects = resp.message;
            }
        },

        normalizeParameters(str, { stripLeadingZeros = true } = {}) {
            return str.replace(/{{\s*(\d+)\s*}}/g, '{{$1}}');
        },

        openNew() {
            this.object = { buttons: [] };
            this.dialog = true;
        },

        confirmDeleteObject(item) {
            this.object = item;
            this.deleteDialog = true;
        },

        openLink(link) {
            window.open(link, "_blank");
        },

        async deleteObject() {
            this.object.filed = true;
            const resp = await Api.deleteTemplateMessage(this.object);

            if (!resp.error && resp.message) {
                emitToastr("success", "Solicitação concluída com sucesso. Aguardar resposta da Meta.");
                this.object = {};
                this.getObjects();
            }
        },

        openObject(item) {
            this.object = item;
            this.dialog = true;
        },

        addButton(data) {
            if (!this.object.buttons) this.object.buttons = [];
            this.object.buttons.push(data);

            this.object.buttons.sort((a, b) => {
                if (a.type === 'QUICK_REPLY' && b.type !== 'QUICK_REPLY') return -1;
                if (a.type !== 'QUICK_REPLY' && b.type === 'QUICK_REPLY') return 1;
                return 0;
            });
        },

        async save() {
            if (!this.object.name) return emitToastr("error", "O nome é um campo necessário");
            if (!this.object.body) return emitToastr("error", "O texto do corpo da mensagem é um campo necessário");

            this.object.body = this.normalizeParameters(this.object.body);

            if (this.object.buttons) {
                //TODO: VALIDAR BOTÕES AQUI
            }

            this.loading = true;
            const resp = await Api.createTemplateMessage(this.object);
            this.loading = false;

            if (!resp.error) {
                emitToastr("success", "Template salvo com sucesso");
                this.getObjects();
                this.dialog = false;
            }
        }
    },
};
</script>

<style scoped></style>